import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import {getRouteMatch} from '../../../../routes/utils';
import {initializePerfWindowMonitoring, observePerfWindow} from './observer';

/** Samples pathname transitions after history commits; the window measures responsiveness. */
export const usePerfWindowMonitoring = () => {
  const history = useHistory();

  useEffect(() => initializePerfWindowMonitoring(), []);

  useEffect(() => {
    let previousPathname = history.location.pathname;
    return history.listen((location, action) => {
      if (location.pathname === previousPathname) {
        return;
      }
      const fromRoutePattern =
        getRouteMatch(previousPathname)?.path ?? 'unmatched';
      const toRoutePattern =
        getRouteMatch(location.pathname)?.path ?? 'unmatched';
      previousPathname = location.pathname;
      observePerfWindow({
        trigger: 'navigation',
        workflow: 'route-changed',
        workflowContext: {
          fromRoutePattern,
          toRoutePattern,
          navigationAction: action,
        },
      });
    });
  }, [history]);
};
